
import { defineComponent, ref, reactive } from 'vue';
import { useFetchData } from '@/utils/hooks/useFetchData';
import { Pagination, TableColumn, TableColumnSortOrder, TableFilters } from '@/typing';
import { useStore } from 'vuex';
import { useTableDynamicColumns } from '@/utils/hooks/useTableColumn';
import { query_customer_list } from '@/api/mjstore-model';

export default defineComponent({
  name: 'TableModal',
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  emits: ['ok', 'cancel'],

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  setup(props: any, { emit }: any) {
    const loading = ref(false);
    const store = useStore();
    const current_org = store.getters['user/current_org'];
    const {
      reload,
      setPageInfo,
      context: state,
    } = useFetchData(query_customer_list, {
      current: 1,
      pageSize: 20,
      tableSize: 'small', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        org_id: current_org.id,
        is_active: true,
        search_text: props.field.search_text,
      },
    });
    const columns = [
      {
        title: '序号',
        dataIndex: 'index',
        width: 50,
        slots: { customRender: 'index' },
      },
      {
        title: '客户ID',
        width: 150,
        dataIndex: 'id',
        checked: false,
      },
      {
        title: '客户编号',
        width: 150,
        dataIndex: 'code',
        checked: true,
      },
      {
        title: '客户名称',
        width: 150,
        dataIndex: 'name',
        checked: true,
      },
      {
        title: '会员等级',
        width: 150,
        dataIndex: 'grade_id',
        checked: true,
      },
      {
        title: '等级名称',
        width: 150,
        dataIndex: 'grade__name',
        checked: true,
      },
      {
        title: '建档日期',
        width: 150,
        dataIndex: 'join_date',
        checked: true,
        slots: { customRender: 'date' },
      },
      {
        title: '性别',
        width: 150,
        dataIndex: 'gender',
        checked: true,
        slots: { customRender: 'gender' },
      },
      {
        title: '出生日期',
        width: 150,
        dataIndex: 'birthday',
        checked: true,

        slots: { customRender: 'date' },
      },
      {
        title: '手机',
        width: 150,
        dataIndex: 'phone',
        checked: true,
      },
      {
        title: '会籍',
        width: 150,
        dataIndex: 'shop_id',
        checked: true,
      },
      {
        title: '门店名称',
        width: 150,
        dataIndex: 'shop__name',
        checked: true,
      },
      {
        title: '创建日期',
        width: 150,
        dataIndex: 'create_time',
        checked: true,
        slots: { customRender: 'datetime' },
      },
      {
        title: '更新时间',
        width: 150,
        dataIndex: 'update_time',
        checked: true,
        slots: { customRender: 'datetime' },
      },
      {
        title: '是否可用',
        width: 150,
        dataIndex: 'is_active',
        checked: true,
        slots: { customRender: 'is_active' },
      },
    ];
    const slotList = [
      {
        slotName: 'index', // 槽名
      },
      {
        slotName: 'status',
        type: 'boolean', // 类型：'boolean' - text字段有无、(true/false)
        name1: '正常', // text字段有或true 展示
        name2: '作废', // text字段无或false 展示
      },
      { type: 'custom', slotName: 'gender', field_0: '男', field_1: '女' },
      {
        slotName: 'is_active',
        type: 'boolean', // 类型：'boolean' - text字段有无、(true/false)
        name1: '可用', // text字段有或true 展示
        name2: '作废', // text字段无或false 展示
      },
      {
        slotName: 'time',
        type: 'time', // 类型：'time' - text字段为时间
      },
      {
        slotName: 'datetime',
        type: 'datetime', // 类型：'datetime' - text字段为日期 时间
      },
      {
        slotName: 'date',
        type: 'date', // 类型：'date' - text字段为日期
      },
      {
        slotName: 'group',
        type: 'list', // 类型：'list' - text字段为数组
      },
    ];

    const { state: columnState, dynamicColumns } = useTableDynamicColumns(
      columns as TableColumn[],
      {
        checkAll: false,
        needRowIndex: false,
      },
    );
    const modalRef = reactive({
      selectedRowsKey: new Array<number>(),
    });

    const rowSelection = {
      type:
        props.field.mode == 'default'
          ? 'radio'
          : props.field.mode == 'multiple'
          ? 'checkbox'
          : 'checkbox',
      columnWidth: '30px',
      // selectedRowKeys: modalRef.selectedRowsKey,
      onChange: (selectedRowKeys: any) => {
        modalRef.selectedRowsKey = selectedRowKeys;
      },
    };

    const handleTableChange = (
      { current, pageSize }: Pagination,
      filters: TableFilters,
      sorter: TableColumnSortOrder,
    ) => {
      console.log(sorter);
      setPageInfo({
        current,
        pageSize,
        ...filters,
        org_id: current_org.id,
        search_text: props.field.search_text,
      });

      reload();
    };

    const handleSubmit = (e: Event) => {
      e.preventDefault();
      if (props.field.mode == 'default') {
        if (modalRef.selectedRowsKey.length == 1) {
          emit('ok', modalRef.selectedRowsKey[0]);
        } else {
          emit('ok', null);
        }
      } else {
        emit('ok', modalRef.selectedRowsKey);
      }
    };

    // 接口返回时间，格式优化
    const getDateTime = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(5, 16);
      } else if (time) {
        time = time.substring(0, 16);
      }
      return time;
    };
    const getDate = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(5, 10);
      } else if (time) {
        time = time.substring(0, 10);
      }
      return time;
    };
    const getFullDate = (time: any) => {
      if (time) {
        time = time.substring(0, 10);
      }
      return time;
    };
    const getTime = (time: any) => {
      if (time) {
        time = time.substring(0, 5);
      }
      return time;
    };

    return {
      props,
      modalRef,
      state,
      loading,
      getDateTime,
      getDate,
      getFullDate,
      getTime,
      handleSubmit,
      handleTableChange,
      rowSelection,
      columnState,
      dynamicColumns,
      slotList,
    };
  },

  data() {
    return {
      model: this.value,
    };
  },
});
